import '../app.css'

// This can be false if you're using a fallback (i.e. SPA mode)
export const prerender = true
